import InnerComponent from '@Components/Sales/SalesOrder/SalesForm';
import orgContainer from '@Components/AppContainer';

const UpdateSalesOrder = () => ((orgContainer(InnerComponent)));
export default UpdateSalesOrder;
